import { Button } from '@/components/ui/button'
import SelectField from 'app/frontend/base/components/form-fields/SelectField'
import TextField from 'app/frontend/base/components/form-fields/TextField'
import { Pencil, UsersRound } from 'lucide-react'
import { useFormContext } from 'react-hook-form'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'

export type EditableAccessRestriction = wowaudit.AccessRestriction & {
  _destroy?: boolean
}

const name = 'access_restrictions_attributes'

const UserRestrictionIdentifierField = ({
  originalIndex,
  readonly,
  destroyed,
  userReferences,
  loading,
}: {
  originalIndex: number
  readonly: boolean
  destroyed?: boolean
  userReferences: wowaudit.UserReference[]
  loading: boolean
}) => {
  const { watch, setValue } = useFormContext()
  const battletag = watch(`${name}.${originalIndex}.battletag`)
  const manualEntry = battletag !== null && battletag !== undefined
  const disabled = !!destroyed || readonly
  const userOptions = userReferences.filter((ref) => ref.obfuscatedBattletag)

  if (!userOptions.length) {
    return (
      <div
        className={`transition-opacity duration-200 ${
          loading ? 'opacity-0' : 'opacity-100'
        }`}
      >
        <TextField
          layout='stacked'
          className={`${destroyed ? 'opacity-30' : ''}`}
          name={`${name}.${originalIndex}.battletag`}
          disabled={disabled}
          customLabel={''}
          customPlaceholder={'Battletag#1234'}
        />
      </div>
    )
  }

  return (
    <div
      className={`flex items-center gap-2 transition-opacity duration-200 ${
        loading ? 'opacity-0' : 'opacity-100'
      }`}
    >
      {manualEntry ? (
        <TextField
          layout='stacked'
          className={`${destroyed ? 'opacity-30' : ''}`}
          name={`${name}.${originalIndex}.battletag`}
          disabled={disabled}
          customLabel={''}
          customPlaceholder={'Battletag#1234'}
        />
      ) : (
        <SelectField<wowaudit.UserReference>
          layout='stacked'
          className={`${destroyed ? 'opacity-30' : ''}`}
          name={`${name}.${originalIndex}.userId`}
          options={userOptions}
          disabled={disabled}
          customLabel={''}
          customPlaceholder={'Select user'}
          optionLabelKey='obfuscatedBattletag'
          optionValueKey='id'
        />
      )}
      <span>or</span>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            type='button'
            variant='outline'
            size='icon'
            className='h-10 w-10 shrink-0'
            disabled={disabled}
            onClick={() => {
              if (manualEntry) {
                setValue(`${name}.${originalIndex}.battletag`, null)
                return
              }

              setValue(`${name}.${originalIndex}.userId`, null)
              setValue(`${name}.${originalIndex}.battletag`, '')
            }}
          >
            {manualEntry ? <UsersRound size={14} /> : <Pencil size={14} />}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          {manualEntry ? 'Choose existing user' : 'Enter manually'}
        </TooltipContent>
      </Tooltip>
    </div>
  )
}

export default UserRestrictionIdentifierField
